import React, { useEffect, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import Loading from '../assetLibComponents/Loading'
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetchAccountList, fetchStar, postRemoveStar, postStar } from '../../redux/actions/accountAction';
import ResponsivePagination from 'react-responsive-pagination';
import TabManagement from "../TabManagement";
import moment from "moment";
import { DateRange, DateRangePicker } from "react-date-range";
import { FaStar } from "react-icons/fa";
import { getFollowListSetup, intentFavorite } from '../../redux/actions/intentAction';


const SettingAccount = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyListing = useSelector((state) => state.account?.account_list?.data);
  const fList = useSelector((state) => state.intent?.followListSetup);
  const companyListTotal = useSelector((state) => state.account?.account_list?.total_count);
  const [pError, setPError] = useState(false);
  const sData = useSelector((state) => state.account?.starData)
  const uData = JSON.parse(localStorage.getItem("userData"));
  const isLoading = useSelector((state) => state.setting.loading);
  const [tabName, setTabName] = useState("Account View");
  const [selectedStar, setSelectedStar] = useState([]);
  const [page, setPage] = useState("1")
  const currentDate = moment();
  const [searchValue, setSearchValue] = useState("");
  const [sortVal, setSortVal] = useState("")
  const [rangeString, setRangeString] = useState("all");
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = React.useState({
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);


  const toggleId = (id) => {
    let str = id.toString();
    setSelectedStar(prevArray => {
      if (prevArray?.includes(str)) {
        dispatch(postRemoveStar(props.authToken,[str],"company"));
        return prevArray.filter(item => item !== str);
      } else if(fList?.details?.company.length < uData?.data?.company) {
        dispatch(getFollowListSetup(props.authToken));
        dispatch(postStar(props.authToken,[str],"company"));
        return [...prevArray, str];
      }else{
      setPError(true)
      }
    });
  };

  useEffect(()=>{
    if(sData?.list?.company?.length > 0){
      setSelectedStar(sData?.list?.company)
    }
  },[sData])


  const handleCalendar = (ranges) => {
    setShowCalendar(false);
    const { startDate, endDate } = selectedDates[0];
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const formattedRange = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    setDateRange(formattedRange);
  };

  
  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };
  
  const tabs = [
    { name: "Lead View", href: "/Lead-Management", current: false },
    { name: "Account View", href: "/Account", current: true },
  ];
  
  const nextPage = (e) => {
    setPage(e);
    dispatch(fetchAccountList(props.authToken,"",e,sortVal,dateRange?.startDate,
    dateRange?.endDate));
  }
  
  // const deleteEvent = () => {
  //   dispatch(deleteUser(authToken, deleteData));
  //   handleClose();
  // };
  
  useEffect(() => {
    dispatch(fetchAccountList(props.authToken,"",1));
    dispatch(fetchStar(props.authToken));
    dispatch(getFollowListSetup(props.authToken));
  }, []);


  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(fetchAccountList(props.authToken,e.target.value,1));
  }

  const handleCloseSearch = () => {
    setSearchValue("");
    dispatch(fetchAccountList(props.authToken,"",1));
  }

  const handleTagClick = (buttonType) => {
    setShowCalendar(false);
    const currentDate = moment();
    setRangeString(buttonType);
    setSelectedDates([
      {
        startDate: new Date(),
        endDate: null,
        key: "selection",
      },
    ]);

    switch (buttonType) {
      case "all":
        setDateRange({
          startDate: "",
          endDate: "",
        });
        break;
      case "today":
        setDateRange({
          startDate: currentDate.format("YYYY-MM-DD"),
          endDate: currentDate.format("YYYY-MM-DD"),
        });
        break;
      case "yesterday":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          endDate: currentDate.clone().subtract(1, "day").format("YYYY-MM-DD"),
        });
        break;
      case "lastWeek":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "week")
            .startOf("week")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "week")
            .endOf("week")
            .format("YYYY-MM-DD"),
        });
        break;
      case "lastMonth":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        });
        break;
      default:
        // Default case
        break;
    }
  };

  useEffect(() => {
    dispatch(
      fetchAccountList(
        props.authToken,"",page,sortVal,
        dateRange?.startDate,
        dateRange?.endDate
      )
    );
  }, [dateRange]);
  useEffect(() => {
    setPage(1)
    dispatch(fetchAccountList(props.authToken,"",0,sortVal,dateRange?.startDate,
    dateRange?.endDate));

  }, [sortVal]);

  const handleFav = (fid,type) => {
    dispatch(intentFavorite(props.authToken,fid,type,"",""));
  };

  return (
     <>
      {isLoading && <Loading />}
        <>
        <div className="pt-[2rem] bg-gray-100 h-[91.5vh] w-full">
          <div className="mx-12 max-sm:mx-4 flex max-sm:flex-col justify-between border-b border-gray-200 mb-3 mt-1 my-auto">
            <TabManagement tabs={tabs} setTabName={setTabName} tabName={tabName} />  
            <div className="top flex max-lg:justify-start justify-center pb-4 pt-1  sm:ml-60 my-auto sm:mr-auto ">
          <div className="flex max-sm:block my-auto items-center relative">
            {/* <div className="text-lg leading-7 font-[500] mr-2 max-sm:my-4">
            Conversation History
          </div> */}
            <div className="tagsContainer flex max-sm:mb-[35px]">
              <div
              className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                rangeString === "all"
                  ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                  : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
              }`}
              onClick={() => {
                handleTagClick("all");
              }}
            >
              All
            </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "today"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("today");
                }}
              >
                Today
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "yesterday"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("yesterday");
                }}
              >
                Yesterday
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "lastWeek"
                    ? " border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastWeek");
                }}
              >
                Last Week
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] border cursor-pointer mr-1  ${
                  rangeString === "lastMonth"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastMonth");
                }}
              >
                Last Month
              </div>
              {dateRange.endDate !== null && rangeString === "calendar" && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:absolute max-sm:bottom-0 max-sm:text-[10px] cursor-pointer me-1 ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : ""
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                  }}
                >
                  {dateRange?.startDate}/{dateRange?.endDate}
                </div>
              )}
              {(selectedDates[0].endDate == null ||
                dateRange.endDate == null) && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:absolute max-sm:bottom-0 max-sm:text-[10px] flex mr-1 my-auto cursor-pointer ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                    setDateRange({
                      startDate: null,
                      endDate: null,
                    });
                  }}
                >
                  Choose Time Duration{" "}
                  <Icon.CalendarDate className="ml-1 my-auto" />
                </div>
              )}
              {showCalendar && (
                <div className="font-[Inter] z-[20] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] bg-[white] left-3/4 top-[119%] z-10 border border-gray-400 max-sm:left-0 max-sm:top-full text-xs mr-1 my-auto absolute">
                  <DateRange
                    editableDateInputs={true}
                    onChange={(ranges) => {
                      setSelectedDates([ranges.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={selectedDates}
                    showMonthAndYearPickers={true}
                    showDateDisplay={false}
                    // initialFocusedRange={[17-18]}
                  />
                  <div className="flex w-full">
                    <div className="ms-auto flex">
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer mr-2"
                        onClick={() => setShowCalendar(false)}
                      >
                        Cancel
                      </div>
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer"
                        onClick={() => {
                          handleCalendar();
                        }}
                      >
                        OK
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>           
          </div>
          <div className="w-full flex justify-between pb-2 px-12 max-sm:px-4">
            <div className="relative rounded-md shadow-sm my-auto w-[30%] max-sm:w-[50%]">
              <DebounceInput
                value={searchValue}
                className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                placeholder="Search Company..."
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearch}
              />
              <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                {searchValue && searchValue !== "" ? (
                  <Icon.X
                    className="h-4 w-4 text-gray-400 pointer"
                    onClick={handleCloseSearch}
                  />
                ) : (
                  <Icon.Search
                    className="h-4 w-4 text-gray-400 cursor-pointer"
                    onClick={handleSearch}
                  />
                )}
              </div>
            </div>
            <div className="flex rightTop">
              <div className="filterContainer flex items-center">
                {/* <div className="filterText mr-2">Sort</div> */}
                <div className="filterSelect h-full max-sm:flex max-sm:justify-end">
                  <select
                    aria-label="select-sortby"
                    className="h-[90%] block w-full max-sm:w-[100%] rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-[0.7rem]"
                    onChange={(e) => {
                      // setFilterByOption(e.target.value);
                      let fiValue;
                      if (e.target.value === "null") {
                        fiValue = "";
                      } else {
                        setSortVal(e.target.value)
                          fiValue = e.target.value;
                          dispatch(fetchAccountList(props.authToken, "", page, fiValue));
                          setPage(1);
                      }
                    }}
                    // value={filterByOption}
                  >
                    <option value="" className="hidden">Sort</option>
                    <option value="asc">Activity (Asc)</option>
                    <option value="desc">Activity (Dsc)</option>
                    {/* <option value="t-asc">Title (A to Z)</option>
                    <option value="t-desc">Title (Z to A)</option> */}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="max-sm:mt-0 flow-root px-4">
          {pError && <div className="text-sm text-red-500 leading-7 font-[500] my-auto cursor-default sm:px-6 lg:px-8">Upgrade your plan from <span onClick={()=>{navigate(`/Setting/billing`)}} className="cursor-pointer underline">here</span></div>}

            <div className='max-sm:overflow-auto listing'>
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="pb-1 rounded-lg overflow-y-auto xl:h-[58vh] md:h-[50vh] h-[55vh] max-sm:h-[60vh] bg-[#ffffff] listing shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50 sticky top-0 z-10">
                      <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          Company Name
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Website
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Mobile
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Date
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        </th>
                      </tr>
                    </thead>
                    { companyListing?.length > 0 && <tbody className="divide-y divide-gray-200 bg-white">
                      {companyListing.map((user,index) => (
                        <tr key={index}>
                          <td className="flex items-center whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            <div className="bg-amber-100 rounded-[50%] flex w-8 h-8 flex-col justify-center items-center gap-[17.5px] shrink-0 p-[12.25px] mr-4">
                                <span className="capitalize text-amber-500 text-center text-base not-italic font-semibold leading-6">{getChars(user.name || "Unknown")}</span>
                              </div>
                              <div
                                className={"cursor-pointer whitespace-nowrap block overflow-hidden text-ellipsis w-[60%] text-sm not-italic font-semibold leading-5" + ((false) ? " flex items-center " : "")}
                                onClick={() => {
                                  navigate(
                                    `/Account/companyDetail/${user.id}`
                                  );
                                }}
                              >
                                {user.name || "-"}
                              </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500">
                            <div
                              title={user.company_website}
                              onClick={() => {
                                navigate(
                                  `/Account/companyDetail/${user.id}`
                                );
                              }}
                              className='cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis w-[80%]'>{user.company_website}</div>  
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{"-"}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user?.created_at?.slice(0, 10)}</td>
                          <td className="px-3 py-4 text-sm text-gray-500">
                            {user?.follow ? <div className='text-sm font-bold cursor-pointer' onClick={()=>toggleId(user.id)}>Unfollow</div>:<div className='text-sm font-bold cursor-pointer' onClick={()=>toggleId(user.id)}>Follow</div>}
                          {/* <FaStar className={`${selectedStar?.includes(user.id.toString()) && "text-blue-400" } text-lg cursor-pointer`} onClick={()=>toggleId(user.id)}/> */}
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500">
                          {user?.follow && <FaStar className={`${user?.is_favorite && "text-blue-400" } text-lg cursor-pointer`} onClick={()=>handleFav(user.follow_id,!user?.is_favorite)}/>}
                          </td>
                        </tr>
                      ))}
                    </tbody>}
                  </table>
                  {( companyListing?.length === 0 ) && (
                    <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[10%] font-[bolder] font-add text-center">
                      <span className="flex justify-center text-[40px]">
                        <Icon.Inbox />
                      </span>
                      No Data
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {companyListTotal > 10 && <div className="flex mx-4 sm:mx-6 lg:mx-12 my-2">
            <div className="me-auto">
              <ResponsivePagination
                current={page}
                total={Math.ceil(companyListTotal/10)}
                onPageChange={nextPage}
              />
            </div>
          </div>}
        </div>
        </>
    </>
    )
}

export default SettingAccount;